import {
  adminHref,
  parseAdminLocation,
  splitPath,
  type AdminLocation,
} from "../features/admin/adminRoute";

export type AppRoute =
  | { kind: "home" }
  | { kind: "profile" }
  | { kind: "abilities" }
  | ({ kind: "admin" } & AdminLocation)
  | { kind: "ability"; abilityId: string; viewId: string }
  | { kind: "record"; abilityId: string; viewId: string; recordId: string }
  | { kind: "preview"; abilityId: string }
  | { kind: "proposal"; proposalId: string }
  | { kind: "assistantJob"; jobId: string }
  | { kind: "print"; abilityId: string; formId: string };

export function parseRoute(pathname: string): AppRoute {
  const { parts, search } = splitPath(pathname);
  if (parts.length === 0) return { kind: "home" };
  if (parts[0] === "profile") return { kind: "profile" };
  if (parts[0] === "abilities") return { kind: "abilities" };
  if (parts[0] === "admin")
    return { kind: "admin", ...parseAdminLocation(parts.slice(1), search) };
  if (parts[0] === "preview" && parts[1])
    return { kind: "preview", abilityId: parts[1] };
  if (parts[0] === "proposals" && parts[1])
    return { kind: "proposal", proposalId: parts[1] };
  if (parts[0] === "assistant" && parts[1] === "jobs" && parts[2])
    return { kind: "assistantJob", jobId: parts[2] };
  if (parts[0] === "print" && parts[1] && parts[2])
    return { kind: "print", abilityId: parts[1], formId: parts[2] };
  if (parts[0] === "ability" && parts[1] && parts[2] && parts[3])
    return {
      kind: "record",
      abilityId: parts[1],
      viewId: parts[2],
      recordId: parts[3],
    };
  if (parts[0] === "ability" && parts[1] && parts[2])
    return { kind: "ability", abilityId: parts[1], viewId: parts[2] };
  return { kind: "home" };
}

export function routeHref(route: AppRoute): string {
  if (route.kind === "home") return "/";
  if (route.kind === "profile") return "/profile";
  if (route.kind === "abilities") return "/abilities";
  if (route.kind === "admin") return adminHref(route);
  if (route.kind === "ability")
    return `/ability/${route.abilityId}/${route.viewId}`;
  if (route.kind === "record")
    return `/ability/${route.abilityId}/${route.viewId}/${route.recordId}`;
  if (route.kind === "preview") return `/preview/${route.abilityId}`;
  if (route.kind === "proposal") return `/proposals/${route.proposalId}`;
  if (route.kind === "assistantJob") return `/assistant/jobs/${route.jobId}`;
  return `/print/${route.abilityId}/${route.formId}`;
}

/** Identity of the screen a route shows; per-screen UI state keys off it. */
export function routeKey(route: AppRoute): string {
  const abilityId = "abilityId" in route ? route.abilityId : "";
  const viewId = "viewId" in route ? route.viewId : "";
  return `${route.kind}:${abilityId}:${viewId}`;
}
